<template>
  <div :class="`wd-100p rounded-10 bg-white mg-b-25 bd-l bd-5 bd-${invoice.isTender?'success':'light'} pd-20`" 
  style="border-width: 10px">
    <div class="d-flex justify-content-between">
      <div>
        <div class="text-muted">Огноо</div>
        <div class="tx-rubik tx-24 text-muted">{{ invoice.createdDate | moment("YYYY.MM.DD") }}</div>
      </div>
      <div class="wd-50p">
        <div v-if="invoice.thirdOrganizationTask != undefined">
          <h6>{{ invoice.thirdOrganizationTask.task }}</h6>
          <!-- <span>{{ invoice.thirdOrganizationTask.objectTypeId }}</span> -->
        </div>
        <div v-else>
          <h6>{{ invoice.task }}</h6>
          <!-- <span>{{invoice.objectTypeId}}</span> -->
        </div>
      </div>
      <div></div>
      <div>
        <div class="text-muted">Дүн</div>
        <div class="tx-rubik tx-24">{{ invoice.budget | formatMoney(0, ".", ",") }} ₮</div>
      </div>
      <div class="d-flex align-items-center">
          <div v-if="!invoice.isTender" class="btn-group mg-l-auto">
            <button class="btn btn-rounded btn-sm pd-x-15 btn-primary btn-uppercase">
              Төлөх
            </button>
            <button @click.prevent="$emit('on-delete', invoice)" class="btn btn-rounded btn-sm pd-x-15 btn-danger btn-uppercase">
              устгах
            </button>
          </div>
          <template v-else>
            <template v-if="hasEbarimt">
              <button
                v-if="invoice.isTender"
                class="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5"
              >
                И-Баримт
              </button>
            </template>
            <span v-else class="badge badge-success">Төлөгдсөн</span>
          </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoice: {
      type: Object,
      default: () => null
    },
    hasEbarimt: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>
